import Vue from 'vue';

// axios
import axios from 'axios';

const axiosIns = axios.create({
    // Remove baseURL - use relative URLs for proxy
    // baseURL will only be used for external APIs that shouldn't go through proxy
    baseURL: '',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

const backendBase = (process.env.VUE_APP_SERVICE_URL || '').replace(/\/+$/, '');

// Normalize GET URLs: drop trailing slash (except root) so DRF serves list endpoints instead of link metadata
const normalizeGetUrl = (url, method) => {
  if (!url || typeof url !== 'string' || (method && method.toLowerCase() !== 'get')) {
    return url;
  }
  const [path, query] = url.split('?');
  const trimmed = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
  return query ? `${trimmed}?${query}` : trimmed;
};

const rewriteToProxy = (url) => {
    // Keep already-proxied paths
    if (!url || typeof url !== 'string' || url.startsWith('/api/') || url.startsWith('/auth/')) {
        return url;
    }

    try {
        const baseForParsing = backendBase || (typeof window !== 'undefined' ? window.location.origin : '');
        const parsed = new URL(url, baseForParsing);
        const backendHost = backendBase ? new URL(backendBase, baseForParsing).host : null;

        // Only rewrite calls intended for our backend (matching host or /v1/ prefix)
        if ((backendHost && parsed.host === backendHost) || parsed.pathname.startsWith('/v1/')) {
            const pathname = parsed.pathname.replace(/^\/?v1\//, '');
            const search = parsed.search || '';
            return `/api/${pathname.replace(/^\/+/, '')}${search}`;
        }
    } catch (e) {
        // fall through; return original url
    }

    return url;
};

axiosIns.interceptors.request.use((config) => {
    const nextConfig = { ...config };
    nextConfig.url = normalizeGetUrl(config.url, config.method);
    nextConfig.url = rewriteToProxy(nextConfig.url);
    return nextConfig;
});

// Add response interceptor for debugging
axiosIns.interceptors.response.use(
    response => response,
    error => {
        return Promise.reject(error);
    }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
